var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FileInput',_vm._g(_vm._b({staticClass:"image-input",attrs:{"accept":_vm.imageExtensions},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return (_vm.showPreview)?[_vm._t("preview",[_c('FilePreview',{attrs:{"file":file,"type":"image"}})],null,{ file: file })]:undefined}}],null,true)},'FileInput',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }